import { Navigate, NavLink, Route, Routes, useMatch } from 'react-router-dom';

import Page from '@sayyesschool/frontend/components/page';

import Packs from '@/components/packs';
import { RequestsSettings } from '@/components/requests';
import Rooms from '@/components/rooms';
import TestSettings from '@/components/settings/test-settings';

const routes = [
    {
        key: 'rooms',
        url: '/settings/rooms',
        content: 'Аудитории',
        component: Rooms
    },
    {
        key: 'requests',
        url: '/settings/requests',
        content: 'Заявки',
        component: RequestsSettings
    },
    {
        key: 'packs',
        url: '/settings/packs',
        content: 'Пакеты',
        component: Packs
    },
    {
        key: 'test',
        url: '/settings/test',
        content: 'Тест',
        component: TestSettings
    }
];

export default function SettingsPage() {
    const match = useMatch('/settings/:view');

    return (
        <Page className="SettingsPage">
            <Page.Header
                title="Настройки"
                tabs={{
                    defaultValue: match?.pathname,
                    items: routes.map(route => ({
                        key: route.key,
                        as: NavLink,
                        to: route.url,
                        content: route.content,
                        value: route.url
                    }))
                }}
            />

            <Page.Content>
                <Routes>
                    <Route
                        path="/"
                        element={<Navigate to={routes[0].url} />}
                    />

                    {routes.map(tab => (
                        <Route
                            key={tab.key}
                            path={tab.key}
                            element={<tab.component />}
                        />
                    ))}
                </Routes>
            </Page.Content>
        </Page >
    );
}